import { render, staticRenderFns } from "./IncomePdf.vue?vue&type=template&id=2fc68db6&scoped=true&"
import script from "./IncomePdf.vue?vue&type=script&lang=js&"
export * from "./IncomePdf.vue?vue&type=script&lang=js&"
import style0 from "./IncomePdf.vue?vue&type=style&index=0&id=2fc68db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc68db6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
